import { getAadGraphResourceName } from '@microsoft/portal-app/lib/aad-graph-api/getAadGraphResourceName';
import { IAjaxRequest } from '@microsoft/portal-app/lib/auth';
import { getApiServerUrl } from '@microsoft/portal-app/lib/environment';
import { OrgId } from '@microsoft/portal-app/lib/Organization/models/IOrganization';
import { AjaxRequest } from 'rxjs';
import { dynamicsConstants } from '../../Privacy/redux';
import { settingsManager } from '../../shared/settings';
import { getMSGraphScopeAndEndPoint } from '../../shared/utils';
import { getPhotoUrl, getUserInfoUrl } from './graphApis';
import { MSGraphScopes } from '../../shared/constants';

export const getDevicesAADGraphApiUrl = () => getApiServerUrl(`/api/devices`);

export const getDevicesApiUrl = () => getApiServerUrl(`/api/devices`);

const msGraphRootUrl = settingsManager.get('msGraphResourceName');
const msGraphBetaUrl = `${msGraphRootUrl}/beta`;
const msGraphV1Url = `${msGraphRootUrl}/v1.0`;

export const getSignedInUserUrl = (): IAjaxRequest => {
  return {
    url: getUserInfoUrl(),
    audience: getMSGraphScopeAndEndPoint(MSGraphScopes.UserReadAll).scope,
  };
};

export const getUserImageRequest = (): IAjaxRequest => {
  return {
    url: getPhotoUrl(),
    audience: getMSGraphScopeAndEndPoint(MSGraphScopes.UserReadAll).scope,
    responseType: 'blob',
  };
};

export const getDisableDevicesApiUrl = (deviceId: string, encode: boolean = true) =>
  getApiServerUrl(`/api/devices/${encode ? encodeURIComponent(deviceId) : deviceId}/disable`);

export const getSignOutApiUrl = () => getApiServerUrl(`/api/signOutEverywhere`);

export const getLeaveOrganizationApiUrl = (tenantId: OrgId, encode: boolean = true) =>
  getApiServerUrl(`/api/organizations/${encode ? encodeURIComponent(tenantId) : tenantId}/leave`);
export const getLinkedInStatusApiUrl = () =>
  ({
    url: `${msGraphBetaUrl}/me/getLinkedInStatus`,
    audience: msGraphRootUrl,
  } as AjaxRequest);

export const getRevokeLinkedInApiUrl = () =>
  ({
    url: `${msGraphBetaUrl}/me/revokeLocalGrant`,
    audience: msGraphRootUrl,
  } as AjaxRequest);

export const getDynamicsStatusAadUrl = () =>
  ({
    hasXssiResponse: true,
    // tslint:disable-next-line: max-line-length
    url: `https://graph.windows.net/myorganization/servicePrincipalsByAppId/65e06b58-87c6-424a-a617-0549251d5679?api-version=1.6`,
    audience: getAadGraphResourceName(),
    sendSessionId: false,
  } as AjaxRequest);

export const getSsprConvergenceUrl = getApiServerUrl('/api/features/isSsprConvergenceEnabled');

export const getConvergedUXV2Url = getApiServerUrl('/api/features/isConvergedUXV2Enabled');

export const getAvailableLanguagesUrl = () => {
  return getApiServerUrl('/api/availableLanguages');
};

export const getRegionDateTimeFormatUrl = (bcp47tag: string) =>
  getApiServerUrl(`/api/dateTimeFormats`) + `?bcp47tag=${bcp47tag}`;

export const getBitlockerKeysUrl = (deviceId?: string): IAjaxRequest => {
  return {
    url: `${msGraphBetaUrl}/informationProtection/bitlocker/recoveryKeys?$filter=deviceId eq '${deviceId}'`,
    audience: getMSGraphScopeAndEndPoint(MSGraphScopes.BitlockerKeyReadAll).scope,
    headers: {
      'ocp-client-name': 'MyAccount',
      'ocp-client-version': '1',
    },
  };
};

export const getBitlockerRecoveryKeyUrl = (bitlockerKey?: string): IAjaxRequest => {
  return {
    url: `${msGraphBetaUrl}/informationProtection/bitlocker/recoveryKeys/${bitlockerKey}?$select=key`,
    audience: getMSGraphScopeAndEndPoint(MSGraphScopes.BitlockerKeyReadAll).scope,
    headers: {
      'ocp-client-name': 'MyAccount',
      'ocp-client-version': '1',
    },
  };
};

export const getDevicesMSGraphUrl = (): IAjaxRequest => {
  return {
    url: `${msGraphV1Url}/me/ownedDevices`,
    audience: getMSGraphScopeAndEndPoint(MSGraphScopes.UserReadAll).scope,
  };
};
